import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "./Project.css";

  import { createTheme } from "@mui/material/styles";
import blue from "@mui/material/colors/blue";
import { ThemeProvider } from "@mui/system";
  

const project = [
  {
    name: "Car Corporation",
    img: "https://i.ibb.co/jH52KQv/1.png",
    description: "",
    technology: "Used Stack",
    stack1: "HTML",
    stack2: "CSS",
    stack3: "Javoascript",
    stack4: "Firebase",
    stack5: "React Js",
    stack6: "Node JS",
    stack7: "Express Js",
    stack8: "Heroku",
    stack9: "MongoDB",
  },
  {
    name: "3A delivery",
    img: "https://i.ibb.co/xGfHqZv/2.png",
    description: "",
    technology: "Used Stack",
    stack1: "HTML",
    stack2: "CSS",
    stack3: "Javascript",
    stack4: "Firebase",
    stack5: "React Js",
    stack6: "Node JS",
    stack7: "Express Js",
    stack8: "Heroku",
    stack9: "MongoDB",
  },
  {
    name: "Ks Hospital",
    img: "https://i.ibb.co/QPWy0f0/3.png",
    description: "",
    technology: "Used Stack",
    stack1: "HTML",
    stack2: "CSS",
    stack3: "Javascript",
    stack4: "Firebase",
    stack5: "React Js",
    stack6: "Node JS",
    stack7: "Express Js",
    stack8: "Heroku",
    stack9: "MongoDB",
  },
]; 
const Projcets = () => {

  const theme = createTheme({
    palette: {
      ownColor: {
        light: "#f00",
        main: "#007",
      },
      secondary: {
        light: "#f00",
        main: "#336b42",
      },
    },
  });
  return (
    <>
     {/* <b className="container-header"> My Projects</b> */}
      <div className="whole-project-container">
      {project.map((p) => (
        <Grid container spacing={2} className="project-container"
          key={p?.name}
        >
          <Grid item sx={12} md={4} sm={12}
            style={{ padding: "1% 1% 2% 4%", margin: '0 auto' }}
          >
            <div
              className="project-images"
              style={{
                backgroundImage: `url(${p.img})`,
              }}
            ></div>
          </Grid>
          <Grid item sx={12} md={8} sm={12} className="projects-info">
            <p className="project-name"> WEB APP PAGE FOR <b>{p.name}</b> </p>
            <Typography variant="body2" className="project-description">Description: Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore corrupti non officia sed exercitationem tempora dolor facere, incidunt iusto quos deleniti, reprehenderit impedit sit a fugiat aspernatur. Ipsa libero voluptate consequatur aliquam laudantium praesentium minima non reprehenderit eaque, dolore assumenda accusamus fuga perspiciatis sed dolorum earum pariatur iusto quos error facere suscipit nulla et nostrum. Beatae sed dicta rem modi, inventore quos eius maxime natus sint maiores, a explicabo?
            </Typography>
            <p>  <b>USED STACK:</b> </p>
            <ThemeProvider theme={theme}>
               
           
            
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack1}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack2}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack3}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack4}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack5}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack6}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack7}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack8}</Button>
            <Button variant="outlined" color="ownColor" sx={{m:1,boxShadow:2}}> {p?.stack9}</Button>
              
              <div> 
                <Button variant="contained" color="secondary" sx={{ m: 1 }}> <a href="https://github.com/ashraful2020" target="_blank" rel="noreferrer"> Live-site</a> </Button>  
                <Button variant="contained" color="secondary" sx={{ m: 1 }}> <a href="https://github.com/ashraful2020" target="_blank" rel="noreferrer"> Client-side-code</a> </Button> 
                <Button variant="contained" color="secondary" sx={{ m: 1 }}> <a href="https://github.com/ashraful2020" target="_blank" rel="noreferrer">Server-Side-code</a> </Button> 
            </div>
            
          
             </ThemeProvider>
          </Grid>
        </Grid>
      ))}
    </div>
    </>
    
  );
};

export default Projcets;
